import { temporarilyNotSupport } from '../../utils'

// 联系人
export const chooseContact = temporarilyNotSupport('chooseContact')
export const addPhoneContact = temporarilyNotSupport('addPhoneContact')
